define('Google.SiteReviews.Model', [
    'Backbone',
    'Backbone.CachedModel',
    'underscore',
    'Utils'
], function GoogleSiteReviewsModel(
    Backbone,
    CachedModel,
    _
) {
    'use strict';

    return CachedModel.extend({
        urlRoot: _.getAbsoluteUrl(getExtensionAssetsPath('services/Google.SiteReviews.Service.ss')),
        initialize: function initialize(attributes) {
            this.on('change:reviews', function changeReviews(model, reviews) {
                model.set('reviews', new Backbone.Collection(reviews), { silent: true });
            });
            this.trigger('change:reviews', this, (attributes && attributes.reviews) || []);
        }
    });
});
